import React from 'react';

import { createAdminNotificationPanelLayoutClassName } from './adminNotificationPanelLayoutStyles';

type Props = {
  leftSlot: React.ReactNode;
  rightSlot: React.ReactNode;
};

export const AdminNotificationPanelLayout = (props: Props) => {
  const { leftSlot, rightSlot } = props;

  const wrapperClassName = createAdminNotificationPanelLayoutClassName(
    'wrapper'
  );

  const leftSlotClassName = createAdminNotificationPanelLayoutClassName(
    'leftSlot'
  );

  const rightSlotClassName = createAdminNotificationPanelLayoutClassName(
    'rightSlot'
  );

  return (
    <div className={wrapperClassName}>
      <div className={leftSlotClassName}>{leftSlot}</div>
      <div className={rightSlotClassName}>{rightSlot}</div>
    </div>
  );
};
